'use strict';

const ANSWER_STATUSES = {
    INCORRECT: 0,
    CORRECT: 1,
    NOT_EVALUATED: 2,
    SKIPPED_CORRECT: 3, // статус присутствует только на фронтенде
};

module.exports.ANSWER_STATUSES = ANSWER_STATUSES;

const CLESSON_MODES = {
    LESSON: 1,
    CONTROL_WORK: 2,
    WEBINAR: 3,
    ADAPTIVE: 4,
    LECTURE: 5,
};

const COURSES_MODES = {
    USUAL: 1,
    BOOK: 2,
    OLYMP: 3,
    RATING: 4,
};

const COURSE_DISPLAY_LOCATION = {
    HEADER: 'header',
    INVISIBLE_FOR_TEACHER: 'invisible_for_teacher',
    COMMON: 'common',
};

const OLYMP_COURSE_THEME = 'ilovemaths';

const LESSONS_PAGE_SIZE = 10;
const SPEC_COURSE_LESSONS_PAGE_SIZE = 50;

const NEW_LESSON_ID = 'new';

const SUBJECTS_SLUGS = {
    olymp: 'olymp',
    roverRob: 'rover_rob',
    russian: 'russian',
    mathematics: 'mathematics',
    custom: 'custom',
    nature: 'nature',
    music: 'music',
    informatics: 'informatics',
    algebra: 'algebra',
    functionalLiteracy: 'functional-literacy',
};

const CHILD_LESSONS_TYPES = {
    ASSIGNED: 'assigned',
    ACTIVE: 'active',
    FINISHED: 'finished',
};

module.exports.CHILD_LESSONS_TYPES = CHILD_LESSONS_TYPES;

const INITIAL_SUBJECT = SUBJECTS_SLUGS.mathematics;

const CONTROL_WORK_STATUSES = {
    OPEN: 'open', // открыта для решения
    READ_ONLY: 'readonly', // решена учеником, нажата кнопка сдать работу либо же время вышло
    RESULTS_RELEASED: 'results_released', // уже доступны результаты, есть кнопка посомотреть правильный ответ
};

const ACTUAL_THEMES_ROOT_ID = 1000000000;

module.exports.CONTROL_WORK_STATUSES = CONTROL_WORK_STATUSES;

// Курс по умолчанию
module.exports.INITIAL_SUBJECT = INITIAL_SUBJECT;

// Тема курса
module.exports.OLYMP_COURSE_THEME = OLYMP_COURSE_THEME;

// Типы курсов
module.exports.COURSES_MODES = COURSES_MODES;

module.exports.COURSE_DISPLAY_LOCATION = COURSE_DISPLAY_LOCATION;

// Типы занятий.
module.exports.CLESSON_MODES = CLESSON_MODES;

module.exports.CLESSON_EDITOR_ALLOWED_MODES = [CLESSON_MODES.CONTROL_WORK, CLESSON_MODES.LESSON];

module.exports.EVALUABLE_CLESSON_MODES = [CLESSON_MODES.CONTROL_WORK];

// количество уроков в 1 чанке (при загрузке курса с уроками с пагинацией)
module.exports.LESSONS_PAGE_SIZE = LESSONS_PAGE_SIZE;

module.exports.SPEC_COURSE_LESSONS_PAGE_SIZE = SPEC_COURSE_LESSONS_PAGE_SIZE;

// слаги предметов
module.exports.SUBJECTS_SLUGS = SUBJECTS_SLUGS;

// фейковый префикс актуальных тем
module.exports.ACTUAL_THEMES_ROOT_ID = ACTUAL_THEMES_ROOT_ID;

// Статусы задач.
module.exports.PROBLEM_STATUSES = {
    INCORRECT: 0,
    CORRECT: 1,
};

// id-шник нового урока
module.exports.NEW_LESSON_ID = NEW_LESSON_ID;

const PROBLEM_STATUS_DISPLAY_NAMES = {
    INCORRECT: 'incorrect',
    CORRECT: 'correct',
    PROGRESS: 'progress',
    SKIPPED: 'skipped',
    NO_ANSWER: 'no-answer',
    NOT_EVALUATED: 'not-evaluated',
    ANSWERED: 'answered',
    NOT_ASSIGNED: 'not-assigned',
};

module.exports.PROBLEM_STATUS_DISPLAY_NAMES = PROBLEM_STATUS_DISPLAY_NAMES;

module.exports.ANSWER_STATUS_TO_DISPLAY_NAME = {
    [ANSWER_STATUSES.INCORRECT]: PROBLEM_STATUS_DISPLAY_NAMES.INCORRECT,
    [ANSWER_STATUSES.CORRECT]: PROBLEM_STATUS_DISPLAY_NAMES.CORRECT,
    [ANSWER_STATUSES.NOT_EVALUATED]: PROBLEM_STATUS_DISPLAY_NAMES.NOT_EVALUATED,
    [ANSWER_STATUSES.SKIPPED_CORRECT]: PROBLEM_STATUS_DISPLAY_NAMES.SKIPPED,
};

// Типы задач.
// TODO: нужен рефакторинг, PROBLEM_TYPES заменить на PROBLEM_LINK_TYPES,
const PROBLEM_TYPES = {
    PROBLEM: 1,
    THEORY: 3,
    EDUCATION: 4,
};

const PROBLEM_INNER_TYPES = {
    PROBLEM: 'practice',
    THEORY: 'theory',
    ROBOT: 'robot',
    EDITABLE: 'editable',
    WEB: 'web',
    CODING: 'coding',
    WEB_SERVICE: 'web_service',
};

const PROBLEM_TYPE_CONSTANTS = {
    [PROBLEM_TYPES.PROBLEM]: { NAME: 'problem', ROUTE: 'problems' },
    [PROBLEM_TYPES.THEORY]: { NAME: 'theory', ROUTE: 'theories' },
};

module.exports.PROBLEM_INNER_TYPES = PROBLEM_INNER_TYPES;
module.exports.PROBLEM_TYPES = PROBLEM_TYPES;
module.exports.PROBLEM_TYPE_CONSTANTS = PROBLEM_TYPE_CONSTANTS;

// Названия типов задач.
module.exports.PROBLEM_TYPE_NAMES = Object.keys(PROBLEM_TYPES).reduce((names, name) => {
    names[PROBLEM_TYPES[name]] = name;
    return names;
}, {});

module.exports.PROBLEMS_PAGE_SIZE = 50;
module.exports.FIRST_PAGE_NUMBER = 1;

module.exports.YASTATIC_HOST = '//yastatic.net/';
module.exports.S3_BASE_HOST = '.s3.yandex.net/';
module.exports.AVATAR_HOST = 'https://avatars.mds.yandex.net';
module.exports.DISK_HOST = 'https://disk.yandex.ru';
module.exports.MAIL_HOST = 'https://mail.yandex.ru';
module.exports.PASSPORT_HOST = 'https://passport.yandex.ru';
module.exports.TUNE_HOST = 'https://tune.yandex.ru';
module.exports.EDUCATION_HOST = 'https://education.yandex.ru';

module.exports.NAME_MAX_LENGTH = 30;

module.exports.SERVICES = {
    EDUCATION: 'education',
    SCHOOL: 'school',
};

// Формат даты и времени
module.exports.DEFAULT_TIME_FORMAT = {
    hour: 'numeric',
    minute: '2-digit',
};

module.exports.DEFAULT_DATE_FORMAT = {
    day: 'numeric',
    month: 'long',
};

module.exports.MAX_STUDENTS_TO_SHOW = 300;

// объединение в блоки
module.exports.LESSON_SCENARIO_VISUAL_MODES = {
    SEPARATE: 0,
    BLOCKS: 1,
};

// Редактор задач
module.exports.MAX_LESSON_PROBLEMS_COUNT = 45;
module.exports.LESSON_DEFAULT_DURATION = 45;
module.exports.LESSON_MAX_DURATION = 65535;

// Задержка между запросами при выполнении задания
module.exports.SPENT_TIME_TICK_DELAY_MS = 180000;

// Время
const MS_IN_SEC = 1000;
const SEC_IN_MIN = 60;
const MIN_IN_HOUR = 60;
const HOURS_IN_DAY = 24;

module.exports.MS_IN_SEC = MS_IN_SEC;
module.exports.SEC_IN_MIN = SEC_IN_MIN;
module.exports.MIN_IN_HOUR = MIN_IN_HOUR;
module.exports.HOURS_IN_DAY = HOURS_IN_DAY;
module.exports.MS_IN_MIN = MS_IN_SEC * SEC_IN_MIN;
module.exports.MIN_IN_DAY = MIN_IN_HOUR * HOURS_IN_DAY;

// Роли
const ROLES = {
    PARENT: 'parent',
    TEACHER: 'teacher',
    CONTENT_MANAGER: 'cm',
    STUDENT: 'student',
    ANONYMOUS: 'anonymous',
};

module.exports.ROLES = ROLES;

// флаг "неполноценности" (нет Я.Паспорта) профиля
module.exports.SEMI_REGISTERED_PASSPORT_FLAG = 'is_social_semi_registered';

// REGEXPS
const POSITIVE_NUMBER_REGEXP_STRING = '\\d*[.,]?\\d+';
const NUMBER_REGEXP_STRING = `(-?${POSITIVE_NUMBER_REGEXP_STRING})`;
const POSITIVE_FRACTION_REGEXP_STRING = `(${POSITIVE_NUMBER_REGEXP_STRING}\\s*\\/\\s*${POSITIVE_NUMBER_REGEXP_STRING})`;
const FRACTION_REGEXP_STRING = `-?${POSITIVE_FRACTION_REGEXP_STRING}`;
const RATIONAL_REGEXP_STRING =
    `(${FRACTION_REGEXP_STRING}|` +
    `${NUMBER_REGEXP_STRING}\\s+${POSITIVE_FRACTION_REGEXP_STRING}|` +
    `${NUMBER_REGEXP_STRING})`;

module.exports.NUMBER_REGEXP_STRING = NUMBER_REGEXP_STRING;
module.exports.RATIONAL_REGEXP_STRING = RATIONAL_REGEXP_STRING;

// set to big value to show every attribute (pagination will be later)
module.exports.ATTRIBUTES_PAGE_SIZE = 1000;

// типы атрибутов проблемов
module.exports.ATTRIBUTE_TYPES = {
    BOOL: 'boolean',
    NUMERIC: 'numeric',
    ENUM: 'enum',
    MULTIPLE_ENUM: 'multiple_enum',
};

// bunker nodes default values
/* eslint-disable camelcase */

const SUBJECT_CONFIG_DEFAULT = {
    initial_subject: 'mathematics',
    list: [
        {
            subject: 'mathematics',
            order: 1,
            has_stacks: true,
            has_grade_difference: true,
            grades_to_preselect: [1, 2, 3, 4],
        },
    ],
};

const SUBJECT_PAGES_DEFAULT = {
    pages: [
        {
            grade: 1,
            // prettier-ignore
            // eslint-disable-next-line max-len
            description: 'borderless,headerless,sameColWidth,percentCols\n|           |           |\n|:--------|:--------|\n|[![Я люблю математику](https://e7n.s3.yandex.net/static/education/olymp2021/lib/main/1-0-1.png){:style=\"max-width: 446px;\"}](./theme/45106/lessons/){:isRouter goalId=\"teacher_vitrina_click_special_accommodation\" sendGoal goaldata_team_level=\"1\" goaldata_subject=\"mathematics\" goaldata_block_position=\"1\"}|[![Весенние задания для первоклассников](https://e7n.s3.yandex.net/static/lib/math/2021/1class/03_04/1-0-2.png){:style=\"max-width: 446px;\"}](./theme/35752/problems/){:isRouter goalId=\"teacher_vitrina_click_problem_of_week\" sendGoal goaldata_team_level=\"1\" goaldata_subject=\"mathematics\" goaldata_block_position=\"1\"}|\n|||\n|||\n|||\n|||\n\nborderless,headerless,sameColWidth,percentCols\n|           |           |\n|:--------|:--------|\n|[{sizedText:large}{coloredText:trueblack}**Готовые занятия на неделю**{\\coloredText}{\\sizedText}](./theme/6891/){:isRouter goalId=\"teacher_vitrina_click_prepared_lesson\" sendGoal goaldata_team_level=\"1\" goaldata_subject=\"mathematics\" goaldata_block_position=\"2\" goaldata_n=\"0\"}||\n|||\n|||\n | [![Знакомимся с числами от 11 до 20](https://e7n.s3.yandex.net/static/lib/math/2021/1class/03_04/1-2-1.png){:style=\"max-width: 446px;\"}](./theme/11716/?preparedLessonId=1061602){:isRouter goalId=\"teacher_vitrina_click_prepared_lesson\" sendGoal goaldata_team_level=\"1\" goaldata_subject=\"mathematics\" goaldata_block_position=\"2\"} | [![Вычитаем из числа 10](https://e7n.s3.yandex.net/static/lib/math/2021/1class/03_04/1-2-2.png){:style=\"max-width: 446px;\"}](./theme/5619/?preparedLessonId=743942){:isRouter goalId=\"teacher_vitrina_click_prepared_lesson\" sendGoal goaldata_team_level=\"1\" goaldata_subject=\"mathematics\" goaldata_block_position=\"2\"}|\n||| \n\n\\tab  \n\nborderless,headerless,sameColWidth,percentCols\n|           |           |\n|:--------|:--------|\n | [![Учимся решать уравнения с неизвестным уменьшаемым](https://e7n.s3.yandex.net/static/lib/math/2021/1class/03_04/1-2-3.png){:style=\"max-width: 446px;\"}](./theme/6094/?preparedLessonId=809280){:isRouter goalId=\"teacher_vitrina_click_prepared_lesson\" sendGoal goaldata_team_level=\"1\" goaldata_subject=\"mathematics\" goaldata_block_position=\"3\"} | [![Учимся решать простые уравнения с неизвестным слагаемым](https://e7n.s3.yandex.net/static/lib/math/2021/1class/03_04/1-2-4.png){:style=\"max-width: 446px;\"}](./theme/7201/?preparedLessonId=4959722){:isRouter goalId=\"teacher_vitrina_click_prepared_lesson\" sendGoal goaldata_team_level=\"1\" goaldata_subject=\"mathematics\" goaldata_block_position=\"3\"}|\n||| \n\n\\tab  \n\nborderless,headerless,sameColWidth,percentCols\n|           |           |           | \n|:--------|:--------|:--------|\n|{sizedText:large}{coloredText:trueblack}**Наши рекомендации**{\\coloredText}{\\sizedText}|||\n||||\n||||\n| [![Запиши ответ к задаче](https://e7n.s3.yandex.net/static/lib/math/2021/1class/03_04/1-3-1.png){:style=\"max-width: 296px;\"}](./theme/11721/?problemId=13428){:isRouter goalId=\"teacher_vitrina_click_actual_problem\" sendGoal goaldata_team_level=\"1\" goaldata_subject=\"mathematics\" goaldata_block_position=\"4\" goaldata_n=\"1\"} | [![Реши уравнение](https://e7n.s3.yandex.net/static/lib/math/2021/1class/03_04/1-3-2.png){:style=\"max-width: 296px;\"}](./theme/7201/?problemId=7204){:isRouter goalId=\"teacher_vitrina_click_actual_problem\" sendGoal goaldata_team_level=\"1\" goaldata_subject=\"mathematics\" goaldata_block_position=\"4\" goaldata_n=\"2\"} |  [![Выбери сосуд, в котором налито указанное число литров](https://e7n.s3.yandex.net/static/lib/math/2021/1class/03_04/1-3-3.png){:style=\"max-width: 296px;\"}](./theme/32359/?problemId=34015){:isRouter goalId=\"teacher_vitrina_click_actual_problem\" sendGoal goaldata_team_level=\"1\" goaldata_subject=\"mathematics\" goaldata_block_position=\"4\" goaldata_n=\"3\"}|\n||||  \n\n\\tab  \n\nborderless,headerless,sameColWidth,percentCols\n|           |\n|:--------|\n|{sizedText:large}{coloredText:trueblack}**Работа в классе**{\\coloredText}{\\sizedText}|\n||\n||\n|[![1](https://e7n.s3.yandex.net/static/lib/math/1class/11_28/1-0-1.png){:style=\"max-width: 896px;\"}](./theme/31944/problems/){:isRouter goalId=\"teacher_vitrina_click_frontal_work\" sendGoal goaldata_team_level=\"1\" goaldata_subject=\"mathematics\" goaldata_block_position=\"5\"}|',
            subject: 'mathematics',
        },
    ],
};

const OLYMP_STUBS_DEFAULT = {
    main: '',
    lessons: [],
};

const BUNKER_NODE_KEYS = {
    TEACHER_RESERVE_ONBOARDING: 'teacherReserveOnboarding',
    TEACHER_RESERVE_INFO: 'teacherReserveInfo',
    ONBOARDING: 'onboarding',
    PRODUCT_TOURS: 'productTours',
    STORIES: 'stories',
    SUBJECT_CONFIG: 'subjectConfig',
    SUBJECT_PAGES: 'subjectPages',
    EXPERIMENTAL_SUBJECT_PAGES: 'subjectPagesExperimental',
    FORMS_CONFIG: 'formsConfig',
    OLYMP_STUBS: 'olympStubs',
    FEATURE_FLAGS: 'featureFlags',
    PLUCKER_CONFIG: 'pluckerConfig',
    PORTFOLIO_CONFIG: 'portfolioConfig',
    TEACHER_TRAINING_COURSES_CONFIG: 'teacherTrainingCoursesConfig',
    TEACHER_EXAMS: 'teacherExams',
    STICKERS: 'stickers',
    TEACHER_BANNERS: 'teacherBanners',
    OLYMPS_CONFIG: 'olympsConfig',
    LIKES_CONFIG: 'likesConfig',
    DIAGNOSTIC_CONFIG: 'diagnosticConfig',
    QUIZ_CONFIG: 'quizConfig',
    PARENT_BANNERS: 'parentBanners',
    STUDENT_BANNERS: 'studentBanners',
    PARENT_ADD_COURSES: 'parentAddCourses',
    VERDICT_THEMES: 'verdictThemes',
    VERDICT_CONFIG: 'verdictConfig',
    PUBLIC_LESSONS_CONFIG: 'publicLessonsConfig',
    MAIL_PERMISSION_CONFIG: 'mailPermissionConfig',
    WEBINARS: 'webinars',
    COURSES_LANDING_DATA: 'coursesLandingData',
    ABOUT_PLUS_KIDS_CONFIG: 'aboutPlusKidsConfig',
    STUDENT_ONBOARDING_BANNERS: 'studentOnboardingBanners',
    MOBILE_VERSION: 'mobileVersion',
    DIAGNOSTICS_LESSONS: 'diagnosticsLessons',
    TEACHER_CHAT_GPT: 'teacherChatGpt',
    DOODLE: 'doodle',
    WEB_VIEW_BASE_URL_DICT: 'webViewBaseUrlDict',
};

const CALENDAR_PLAN_SHOWCASE_CONFIG_DEFAULT = {};
const FEATURE_FLAGS_DEFAULT = {};
const PLUCKER_CONFIG_DEFAULT = {
    teacherHeader: {
        teacherMenu: {
            teacherEducationMenu: {
                enabled: false,
                items: [],
                name: '',
            },
        },
    },
};

const OLYMPS_CONFIG_DEFAULT = {
    olymps: [],
};
const QUIZ_CONFIG_DEFAULT = {
    subjects: [],
    quizzesViewConfig: {
        showcaseQuizzesLimit: 4,
    },
    quizzes: [],
};

const DIAGNOSTIC_CONFIG_DEFAULT = {};

const PUBLIC_LESSONS_CONFIG_DEFAULT = {
    withoutRegistrationModal: [],
};

const TEACHER_TRAINING_COURSES_CONFIG_DEFAULT = {
    courses: [],
    banners: [],
};
const MAIL_PERMISSION_CONFIG_DEFAULT = {
    startDate: '2000-01-01T00:00:00Z',
    descriptionTankerKey: 'mailPermission.description',
};

const COURSES_LANDING_DATA_DEFAULT = {
    contentOrigin: '',
    pages: {},
};

const ABOUT_PLUS_KIDS_CONFIG_DEFAULT = {
    olyLessonIdsByGrade: null,
};

const MOBILE_VERSION_CONFIG_DEFAULT = {
    data: {
        minimalVersion: '0.0.0',
    },
};

module.exports.BUNKER_NODE_KEYS = BUNKER_NODE_KEYS;

module.exports.SUBJECT_CONFIG_DEFAULT = SUBJECT_CONFIG_DEFAULT;
module.exports.OLYMP_STUBS_DEFAULT = OLYMP_STUBS_DEFAULT;

module.exports.CALENDAR_PLAN_SHOWCASE_CONFIG_DEFAULT = CALENDAR_PLAN_SHOWCASE_CONFIG_DEFAULT;
module.exports.PLUCKER_CONFIG_DEFAULT = PLUCKER_CONFIG_DEFAULT;
module.exports.OLYMPS_CONFIG_DEFAULT = OLYMPS_CONFIG_DEFAULT;
module.exports.QUIZ_CONFIG_DEFAULT = QUIZ_CONFIG_DEFAULT;
module.exports.TEACHER_TRAINING_COURSES_CONFIG_DEFAULT = TEACHER_TRAINING_COURSES_CONFIG_DEFAULT;

module.exports.DIAGNOSTIC_CONFIG_DEFAULT = DIAGNOSTIC_CONFIG_DEFAULT;

module.exports.BUNKER_DEFAULT_VALUES = {
    [BUNKER_NODE_KEYS.SUBJECT_CONFIG]: SUBJECT_CONFIG_DEFAULT,
    [BUNKER_NODE_KEYS.SUBJECT_PAGES]: SUBJECT_PAGES_DEFAULT,
    [BUNKER_NODE_KEYS.EXPERIMENTAL_SUBJECT_PAGES]: SUBJECT_PAGES_DEFAULT,
    [BUNKER_NODE_KEYS.OLYMP_STUBS]: OLYMP_STUBS_DEFAULT,
    [BUNKER_NODE_KEYS.CALENDAR_PLAN_SHOWCASE_CONFIG]: CALENDAR_PLAN_SHOWCASE_CONFIG_DEFAULT,
    [BUNKER_NODE_KEYS.TEACHER_TRAINING_COURSES_CONFIG]: TEACHER_TRAINING_COURSES_CONFIG_DEFAULT,
    [BUNKER_NODE_KEYS.FEATURE_FLAGS]: FEATURE_FLAGS_DEFAULT,
    [BUNKER_NODE_KEYS.PLUCKER_CONFIG]: PLUCKER_CONFIG_DEFAULT,
    [BUNKER_NODE_KEYS.OLYMPS_CONFIG]: OLYMPS_CONFIG_DEFAULT,
    [BUNKER_NODE_KEYS.QUIZ_CONFIG]: QUIZ_CONFIG_DEFAULT,
    [BUNKER_NODE_KEYS.PARENT_BANNERS]: [],
    [BUNKER_NODE_KEYS.PARENT_ADD_COURSES]: [],
    [BUNKER_NODE_KEYS.PUBLIC_LESSONS_CONFIG]: PUBLIC_LESSONS_CONFIG_DEFAULT,
    [BUNKER_NODE_KEYS.MAIL_PERMISSION_CONFIG]: MAIL_PERMISSION_CONFIG_DEFAULT,
    [BUNKER_NODE_KEYS.WEBINARS]: [],
    [BUNKER_NODE_KEYS.STUDENT_BANNERS]: { data: [] },
    [BUNKER_NODE_KEYS.COURSES_LANDING_DATA]: COURSES_LANDING_DATA_DEFAULT,
    [BUNKER_NODE_KEYS.ABOUT_PLUS_KIDS_CONFIG]: ABOUT_PLUS_KIDS_CONFIG_DEFAULT,
    [BUNKER_NODE_KEYS.STORIES]: {
        items: [],
    },
    [BUNKER_NODE_KEYS.TEACHER_RESERVE_ONBOARDING]: [],
    [BUNKER_NODE_KEYS.ONBOARDING]: [],
    [BUNKER_NODE_KEYS.PRODUCT_TOURS]: [],
    [BUNKER_NODE_KEYS.STUDENT_ONBOARDING_BANNERS]: { data: [] },
    [BUNKER_NODE_KEYS.TEACHER_RESERVE_INFO]: {
        progressPoints: [],
    },
    [BUNKER_NODE_KEYS.MOBILE_VERSION]: MOBILE_VERSION_CONFIG_DEFAULT,
    [BUNKER_NODE_KEYS.WEB_VIEW_BASE_URL_DICT]: { data: {} },
};

const LESSON_SOURCE_VALUE_FALLBACK = {
    DEEPLINK: 'deeplink',
    UNKNOWN: 'unknown',
};

const LESSON_SOURCE_VALUE = {
    SHOWCASE: 'showcase',
};

const LESSON_SOURCES = {
    ...LESSON_SOURCE_VALUE,
    ...LESSON_SOURCE_VALUE_FALLBACK,
};

const FRONTAL_WORK = 'frontal_work';
const FROM_PROJECT = 'from_project';
const REG_REDIRECT_URL = 'reg_redirect_url';
const IS_OLYMP_ACCEPTED = 'is_olymp_accepted';
const IS_LONG_TERM_OLYMP_ACCEPTED = 'is_long_term_olymp_accepted';
const NEW_SCHOOLBOOK_PREFIX = '/new-lab';

module.exports.LESSON_SOURCE_VALUE_FALLBACK = LESSON_SOURCE_VALUE_FALLBACK;
module.exports.LESSON_SOURCE_VALUE = LESSON_SOURCE_VALUE;
module.exports.LESSON_SOURCES = LESSON_SOURCES;
module.exports.FRONTAL_WORK = FRONTAL_WORK;
module.exports.FROM_PROJECT = FROM_PROJECT;
module.exports.REG_REDIRECT_URL = REG_REDIRECT_URL;
module.exports.IS_OLYMP_ACCEPTED = IS_OLYMP_ACCEPTED;
module.exports.IS_LONG_TERM_OLYMP_ACCEPTED = IS_LONG_TERM_OLYMP_ACCEPTED;
module.exports.PUBLIC_LESSONS_CONFIG_DEFAULT = PUBLIC_LESSONS_CONFIG_DEFAULT;
module.exports.NEW_SCHOOLBOOK_PREFIX = NEW_SCHOOLBOOK_PREFIX;
